'use strict';

var defaultTheme = require('./defaultTheme-ea44e34a.js');
var React = require('react');
var styled = require('styled-components');
var lodash = require('lodash');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var Alert$1 = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject || (_templateObject = defaultTheme._taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding: ", ";\n  width: ", ";\n  box-sizing: border-box;\n\n  ", "\n\n  ", "\n  \n  ", "\n  \n  text-align: ", ";\n"])), function (props) {
  var _props$verticalPaddin, _props$horizontalPadd;

  var verticalPadding = (_props$verticalPaddin = props.verticalPadding) !== null && _props$verticalPaddin !== void 0 ? _props$verticalPaddin : 17;
  var horizontalPadding = (_props$horizontalPadd = props.horizontalPadding) !== null && _props$horizontalPadd !== void 0 ? _props$horizontalPadd : 30;
  return "".concat(verticalPadding, "px ").concat(horizontalPadding, "px");
}, function (props) {
  return props.width ? "".concat(props.width, "px") : '100%';
}, function (props) {
  return props.warning && styled.css(_templateObject2 || (_templateObject2 = defaultTheme._taggedTemplateLiteral(["\n      ", "\n    "])), props.theme.themeProp('background', '#634E01', props.theme.getColor('signal-yellow-400')));
}, function (props) {
  return props.error && styled.css(_templateObject3 || (_templateObject3 = defaultTheme._taggedTemplateLiteral(["\n      ", "\n    "])), props.theme.themeProp('background', '#7F1B1B', props.theme.getColor('red-200')));
}, function (props) {
  return props.info && styled.css(_templateObject4 || (_templateObject4 = defaultTheme._taggedTemplateLiteral(["\n      background: transparent;\n    "])));
}, function (props) {
  return props.align === 'center' ? 'center' : 'left';
});
var AlertRender = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject5 || (_templateObject5 = defaultTheme._taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  word-break: break-word;\n  ", "\n  ", "\n  ", ";\n\n  svg {\n    width: 12px;\n    height: 12px;\n  }\n\n  span {\n    flex: 1;\n    padding-left: 5px;\n    ", ";\n  }\n"])), function (props) {
  return props.lineHeight ? "line-height: ".concat(props.lineHeight, "px;") : null;
}, function (props) {
  return props.fontSize ? "font-size: ".concat(props.fontSize, "px;") : null;
}, function (props) {
  return props.theme.themeProp('color', props.theme.getColor('white'), props.theme.getColor('gray-700'));
}, function (props) {
  return props.lineClamp ? styled.css(_templateObject6 || (_templateObject6 = defaultTheme._taggedTemplateLiteral(["\n            display: -webkit-box;\n            -webkit-line-clamp: ", ";\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          "])), props.lineClamp) : null;
});

var Alert = React__default['default'].forwardRef(function Alert(_ref, forwardedRef) {
  var warning = _ref.warning,
      error = _ref.error,
      type = _ref.type,
      alertMessage = _ref.alertMessage,
      align = _ref.align,
      icon = _ref.icon,
      fontSize = _ref.fontSize,
      lineHeight = _ref.lineHeight,
      lineClamp = _ref.lineClamp,
      verticalPadding = _ref.verticalPadding,
      horizontalPadding = _ref.horizontalPadding,
      width = _ref.width,
      props = defaultTheme._objectWithoutProperties(_ref, ["warning", "error", "type", "alertMessage", "align", "icon", "fontSize", "lineHeight", "lineClamp", "verticalPadding", "horizontalPadding", "width"]);

  var isWarning = false;
  var isError = false;
  var isInfo = true;

  if (!lodash.isEmpty(type)) {
    if (type === 'warning') {
      isWarning = true;
    } else if (type === 'error') {
      isError = true;
    } else {
      isInfo = true;
    }
  } else {
    isWarning = warning;
    isError = error;

    if (isWarning || isError) {
      isInfo = false;
    }
  }

  return React__default['default'].createElement(Alert$1, defaultTheme._extends({
    ref: forwardedRef,
    alertMessage: alertMessage,
    warning: isWarning,
    error: isError,
    info: isInfo,
    align: align,
    verticalPadding: verticalPadding,
    horizontalPadding: horizontalPadding,
    width: width
  }, props), React__default['default'].createElement(AlertRender, {
    fontSize: fontSize,
    lineHeight: lineHeight,
    lineClamp: lineClamp
  }, icon, " ", React__default['default'].createElement("span", null, alertMessage)));
});
Alert.propTypes = process.env.NODE_ENV !== "production" ? {
  warning: defaultTheme.PropTypes.bool,
  error: defaultTheme.PropTypes.bool,
  type: defaultTheme.PropTypes.oneOf(['warning', 'error', 'info']),
  icon: defaultTheme.PropTypes.element,
  align: defaultTheme.PropTypes.oneOf(['left', 'center']),
  alertMessage: defaultTheme.PropTypes.string,
  fontSize: defaultTheme.PropTypes.number,
  lineHeight: defaultTheme.PropTypes.number,
  lineClamp: defaultTheme.PropTypes.number,
  verticalPadding: defaultTheme.PropTypes.number,
  horizontalPadding: defaultTheme.PropTypes.number,
  width: defaultTheme.PropTypes.number
} : {};
Alert.defaultProps = {
  warning: false,
  error: false,
  align: 'left',
  alertMessage: 'Use subject to restrictions. Editorial use only, no commercial use without prior consent from rights holder.',
  lineClamp: 0,
  horizontalPadding: 30,
  verticalPadding: 17
};

exports.Alert = Alert;
